/**
 * UX-1 — fiche U1 → deep link Mes Commandes pour ventes Stripe (navigation uniquement).
 * Feature flag OFF par défaut. Aucun appel remboursement / Stripe / ledger.
 */

export function isU2Ux1StripeMesCommandesFromUnifiedEnabled() {
  const env =
    typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {};
  return env.VITE_U2_UX1_STRIPE_MES_COMMANDES_FROM_UNIFIED === 'true';
}

/**
 * @param {string} commercantId
 * @param {string} commandeId
 * @returns {string} chemin Admin (sans origin)
 */
export function buildMesCommandesDeepLink(commercantId, commandeId) {
  const cid = String(commercantId || '').trim();
  const cmd = String(commandeId || '').trim();
  if (!cid || !cmd) return '';
  const params = new URLSearchParams({ tab: 'commandes', commandeId: cmd });
  return `/commercants/${encodeURIComponent(cid)}?${params.toString()}`;
}

function isStripeRefundRoute(preview) {
  const route = preview?.paymentSummary?.refundRoute || preview?.refundRoute;
  return route === 'STRIPE_WEB';
}

/**
 * @param {object} preview — GET preview U1
 * @param {{ flagEnabled?: boolean, canOpenMesCommandes?: boolean }} [opts]
 * @returns {{ kind: 'hidden'|'disabled_flag'|'disabled_permission'|'action', commandeId?: string, href?: string, message?: string }}
 */
export function resolveU2Ux1StripeMesCommandesHandoff(
  preview,
  opts = {}
) {
  const flagEnabled =
    opts.flagEnabled !== undefined
      ? opts.flagEnabled
      : isU2Ux1StripeMesCommandesFromUnifiedEnabled();
  const canOpenMesCommandes = opts.canOpenMesCommandes === true;

  if (!preview?.commande?.id) {
    return { kind: 'hidden' };
  }
  if (!isStripeRefundRoute(preview)) {
    return { kind: 'hidden' };
  }
  if (!flagEnabled) {
    return {
      kind: 'disabled_flag',
      message:
        'L’ouverture Mes Commandes depuis cette fiche est désactivée (feature flag). Utilisez Mes Commandes depuis le menu commerçant.',
    };
  }
  if (!canOpenMesCommandes) {
    return {
      kind: 'disabled_permission',
      message: 'Accès Mes Commandes indisponible pour votre profil sur cette boutique.',
    };
  }
  const href = buildMesCommandesDeepLink(opts.commercantId, preview.commande.id);
  if (!href) {
    return { kind: 'hidden' };
  }
  return {
    kind: 'action',
    commandeId: preview.commande.id,
    href,
  };
}
